import { render, staticRenderFns } from "./LessonsPage.vue?vue&type=template&id=edec98a6&scoped=true&"
import script from "./LessonsPage.vue?vue&type=script&lang=js&"
export * from "./LessonsPage.vue?vue&type=script&lang=js&"
import style0 from "./LessonsPage.vue?vue&type=style&index=0&id=edec98a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edec98a6",
  null
  
)

export default component.exports